/**
 * scanSettings.js — Tenant-default scan preferences.
 *
 * Wraps GET / PUT /api/scan-settings. Caches in localStorage so the scan
 * screens can render instantly without waiting for the network; falls back
 * to localStorage when offline.
 */
import api from './api';

const LS_KEY = 'stockaris.scan.settings';

export const DEFAULTS = {
  default_submit_mode: 'continuous', // 'continuous' | 'batch'
  default_carton_multiplier: 1,       // integer, >= 1
};

function readCache() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return null;
    return { ...DEFAULTS, ...JSON.parse(raw) };
  } catch { return null; }
}
function writeCache(data) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(data)); }
  catch { /* ignore */ }
}

export async function loadScanSettings() {
  const cached = readCache();
  try {
    const { data } = await api.get('/scan-settings');
    const merged = { ...DEFAULTS, ...data };
    writeCache(merged);
    return merged;
  } catch {
    return cached || DEFAULTS;
  }
}

export async function saveScanSettings(partial) {
  const { data } = await api.put('/scan-settings', partial);
  const merged = { ...DEFAULTS, ...data };
  writeCache(merged);
  return merged;
}

export function getCachedScanSettings() {
  return readCache() || DEFAULTS;
}
